import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_BULK_EMAILS = Symbol('bulk-emails');

export const ADMIN_BULK_EMAILS_ROUTE_NAME = Symbol('admin.bulk-emails');

export const BULK_EMAILS_OPTIONS_URL = 'admin/mailing/options';
export const BULK_EMAILS_OPTIONS_QUERY_KEY = 'bulk-emails.options';

export const BULK_EMAILS_AFFILIATES_LIST_URL = 'admin/mailing/list_affiliates';
export const BULK_EMAILS_AFFILIATES_LIST_QUERY_KEY = 'bulk-emails.affiliates.list';

export const BULK_EMAILS_SEND_URL = 'admin/mailing/send_letter';
export const BULK_EMAILS_SEND_TEST_URL = 'admin/mailing/testing_send_letter';
export const BULK_EMAILS_SEND_MUTATION_KEY = 'bulk-emails.send';

export const BULK_EMAILS_PERMISSIONS = {
  SHOW: new Permission(PermissionsList.admin.MAILING_ALL),
};
